export const HOTEL_PROP_REQUEST = "HOTEL_PROP_REQUEST";
export const HOTEL_PROP_SUCCESS = "HOTEL_PROP_SUCCESS";
export const HOTEL_PROP_PROCESS_STATUS = "HOTEL_PROP_PROCESS_STATUS";
export const HOTEL_PROP_RESET = "HOTEL_PROP_RESET";
export const HOTEL_SET_PROP_CODE = "HOTEL_SET_PROP_CODE";
export const HOTEL_SETTINGS_SUCCESS = "HOTEL_SETTINGS_SUCCESS";
export const HOTEL_PAYMENT_CODE_LIST_REQUEST = "HOTEL_PAYMENT_CODE_LIST_REQUEST";
export const HOTEL_PAYMENT_CODE_LIST_SUCCESS = "HOTEL_PAYMENT_CODE_LIST_SUCCESS";
export const HOTEL_PAYMENT_CODE_LIST_FAILURE = "HOTEL_PAYMENT_CODE_LIST_FAILURE";

export const HOTEL_SETTING_UPDATE_REQUEST = "HOTEL_SETTING_UPDATE_REQUEST";
export const HOTEL_SETTING_UPDATE_SUCCESS = "HOTEL_SETTING_UPDATE_SUCCESS";
export const HOTEL_SETTING_UPDATE_FAILURE = "HOTEL_SETTING_UPDATE_FAILURE";
export const HOTEL_PROFILE_CLEAR_PROCESS = "HOTEL_PROFILE_CLEAR_PROCESS";

export const HOTEL_CHANNEL_LIST_REQUEST = "HOTEL_CHANNEL_LIST_REQUEST";
export const HOTEL_CHANNEL_LIST_SUCCESS = "HOTEL_CHANNEL_LIST_SUCCESS";
export const HOTEL_CHANNEL_LIST_FAILURE = "HOTEL_CHANNEL_LIST_FAILURE";

export type HotelRoom = {
  id: string;
  name: string;
  short: string;
  thumbnail: string;
  highlights: string[];
  amenities: string[];
  images: string[];
};
export type HotelIntro = {
  title: string;
  content: string;
  facilities: string[];
};

export type HotelProfile = {
  hotelBG: string;
  hotelCarousel: string[];
  hotelIntro: HotelIntro;
  hotelRooms: HotelRoom[];
  mapUrl?: string;
  mapUrlEmbed?: string;
  websiteUrl?: string | null;
  address?: string | null;
  emails?: string[];
  phones?: string[];
  fax?: string;
  socialMedia?: {
    facebook?: string | null;
    line?: string | null;
    instagram?: string | null;
    tiktok?: string | null;
  };
};
export type DefaultSearchGuests = {
  adult: number | null;
  child: number | null;
  infant: number | null;
};

export type GalleryMode = 'slide' | 'grid' | 'both' | 'none';

export type HotelSettings = {
  languages: string[];
  theme_code: string;
  allow_extrabed: boolean;
  payment_timeout_min: number;
  timeout_booking_status: string;
  deposit_payment_code?: string | null;
  channel_id?: number | null;
  propCode?: string | null;
  default_search_guests?: DefaultSearchGuests | null;
  gallery_mode?: GalleryMode | null;
  create_payment_link?: boolean;
  booking_cutoff_enabled?: boolean;
  booking_cutoff_time?: string | null;
};
export type PaymentCodeOption = {
  code: string;
  name: string;
};

export type ChannelOption = {
  id: number;
  name: string;
};
export type HotelPropRequest = {
  type: typeof HOTEL_PROP_REQUEST;
  payload?: string;
};
export type HotelSetPropCode = {
  type: typeof HOTEL_SET_PROP_CODE;
  payload: string | null;
};
export type HotelPropSuccess = {
  type: typeof HOTEL_PROP_SUCCESS;
  payload: HotelProfile;
};
export type HotelSettingsSuccess = {
  type: typeof HOTEL_SETTINGS_SUCCESS;
  payload: HotelSettings;
};
export type HotelPaymentCodeListRequest = {
  type: typeof HOTEL_PAYMENT_CODE_LIST_REQUEST;
  payload?: string | null;
};
export type HotelPaymentCodeListSuccess = {
  type: typeof HOTEL_PAYMENT_CODE_LIST_SUCCESS;
  payload: PaymentCodeOption[];
};
export type HotelPaymentCodeListFailure = {
  type: typeof HOTEL_PAYMENT_CODE_LIST_FAILURE;
  payload: string;
};
export type HotelPropProcessStatus = {
  type: typeof HOTEL_PROP_PROCESS_STATUS;
  payload: ProcessType; // set process status
};
export type HotelPropReset = {
  type: typeof HOTEL_PROP_RESET;
};

export type HotelSettingUpdateRequest = {
  type: typeof HOTEL_SETTING_UPDATE_REQUEST;
  payload: Partial<HotelSettings>;
};

export type HotelSettingUpdateSuccess = {
  type: typeof HOTEL_SETTING_UPDATE_SUCCESS;
  payload: HotelSettings;
};

export type HotelSettingUpdateFailure = {
  type: typeof HOTEL_SETTING_UPDATE_FAILURE;
  payload: string;
};

export type HotelProfileClearProcess = {
  type: typeof HOTEL_PROFILE_CLEAR_PROCESS;
};

export type HotelChannelListRequest = {
  type: typeof HOTEL_CHANNEL_LIST_REQUEST;
  payload?: string | null;
};

export type HotelChannelListSuccess = {
  type: typeof HOTEL_CHANNEL_LIST_SUCCESS;
  payload: ChannelOption[];
};

export type HotelChannelListFailure = {
  type: typeof HOTEL_CHANNEL_LIST_FAILURE;
  payload: string;
};

export type HotelProfileAction =
  | HotelPropRequest
  | HotelPropSuccess
  | HotelPropProcessStatus
  | HotelSetPropCode
  | HotelPropReset
  | HotelSettingsSuccess
  | HotelPaymentCodeListRequest
  | HotelPaymentCodeListSuccess
  | HotelPaymentCodeListFailure
  | HotelSettingUpdateRequest
  | HotelSettingUpdateSuccess
  | HotelSettingUpdateFailure
  | HotelProfileClearProcess
  | HotelChannelListRequest
  | HotelChannelListSuccess
  | HotelChannelListFailure;

export type ProcessActionType = "HOTEL_REQUEST" | "HOTEL_SETTING_UPDATE";

/* Reducer type */
export type ProcessType = {
  status: boolean;
  action?: ProcessActionType | null;
  message?: string | null;
};

export type HotelProfileState = {
  loading: boolean;
  dataSource: HotelProfile | null;
  hotelSettings: HotelSettings | null;
  paymentCodeLoading: boolean;
  paymentCodeOptions: PaymentCodeOption[];
  channelLoading: boolean;
  channelOptions: ChannelOption[];
  process: ProcessType;
  propCode: string | null;
};
